import { deleteRamo, getRamosPanel } from "../../services/RamosServices";
import { RamosContext } from "./RamosContext"

export const RamosState = ({ children }) => {

    const getRamosPanelData = async (search, numpag, filas) => {
        let res = await getRamosPanel(search, numpag, filas)
        return res
    }

    const deleteRamoData = async (body,search, numpag, filas) => {
        const res = await deleteRamo(body)
        if (res) getRamosPanelData(search, numpag, filas)
        return res
    }

    return <RamosContext.Provider value={{
        deleteRamoData,
        getRamosPanelData
    }} >
        {children}
    </RamosContext.Provider>
}